import { useCounter } from './useCounter';
import { ActionType } from '../redux/actionType';
import { useStickyDiff } from './useStickyDiff';
import { useErrorOfType } from '../api/hooks';
import * as R from 'ramda';


/**
 * A React Hook that keeps a count of API actions of the provided types, that return with an error
 *
 * @param actionType - the type of API actions to track for success; with each error, the counter increments by 1
 */
export const useCounterOnAnyError = (
  actionType: ActionType,
): [number, () => void] => {
  const [errorCount, incrementErrorCount, resetErrorCount] = useCounter();

  const errorMap = useErrorOfType(actionType);

  useStickyDiff(
    (prev, next) => {
      const returnedReqs = R.difference(Object.keys(next.errorObjs ?? []), Object.keys(prev?.errorObjs ?? []));

      R.forEach(() => incrementErrorCount(), returnedReqs);
    },
    {
      errorObjs: errorMap,
    },
  );

  return [errorCount, resetErrorCount];
};
